// TimelineTab — extracted from ProjectsPage.jsx ({tab === 'timeline' && ...}
// block, lines ~1558–1566 in the legacy file). Same behaviour: premium sees
// TimelineView; free tier sees the locked-preview card.

import React from 'react';
import { useIsPremium } from '../../contexts/PremiumContext';
import { LockedCard } from '../PremiumLock/PremiumLock';
import { TimelineView } from '../Timeline';

export default function TimelineTab() {
  const isPremium = useIsPremium();
  if (isPremium) return <TimelineView />;
  return (
    <LockedCard
      title="Timeline — Premium"
      body="Track every project's stage gates, deadlines, and owner across a single timeline view."
    />
  );
}
